import styled from 'styled-components';
import * as Form from '@radix-ui/react-form';

export const Container = styled(Form.Root)`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[6]}px;
`;

export const CamposFormContainer = styled.div<{ $estiloCustomizado?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[6]}px;

  ${({ $estiloCustomizado }) => $estiloCustomizado};
`;

export const ContainerEtapa = styled.div`
  display: flex;
  flex-direction: column;
`;
